import { Order } from "domain/entities/order";
import searchInstructorsRepository from "../../../../infrastructure/repository/impl/instructors/instructor_repository";
import { Course, Instructor } from "../../../entities/entities";
import InstructorInterface from "./instructorInterface";
import { ListResponse } from "domain/entities/shop/product/listResponse";

class InstructorUseCase implements InstructorInterface {
  async listBySearchInstructors(search: string): Promise<Instructor[]> {
    return await searchInstructorsRepository.listBySearchInstructors(search);
  }

  async getCoursesByInstructors(
    order: Order,
    instructorId: number
  ): Promise<ListResponse<Course[]>> {
    return await searchInstructorsRepository.getCoursesByInstructors(
      order,
      instructorId
    );
  }
}

export default new InstructorUseCase() as InstructorInterface;
